import { Injectable } from '@angular/core';

const THEME_KEY = 'kcms-loyalty-theme';
const FONT_KEY = 'kcms-loyalty-font';
export type AppTheme = 'light' | 'dark';
export type FontScale = 'sm' | 'md' | 'lg';

@Injectable({ providedIn: 'root' })
export class ThemeService {
   theme: AppTheme = 'light';
   fontScale: FontScale = 'md';

   constructor() {
      const stored = this.readStorage(THEME_KEY);
      this.apply(stored === 'dark' ? 'dark' : 'light');
      const scale = this.readStorage(FONT_KEY);
      this.setFontScale(scale === 'sm' || scale === 'lg' ? scale : 'md');
   }

   apply(theme: AppTheme): void {
      this.theme = theme === 'dark' ? 'dark' : 'light';
      this.writeStorage(THEME_KEY, this.theme);
      document.documentElement.classList.toggle('dark-mode', this.theme === 'dark');
   }

   setFontScale(scale: FontScale): void {
      this.fontScale = scale === 'sm' || scale === 'lg' ? scale : 'md';
      this.writeStorage(FONT_KEY, this.fontScale);
      const size = this.fontScale === 'sm' ? '93%' : this.fontScale === 'lg' ? '104%' : '97.75%';
      document.documentElement.style.fontSize = size;
   }

   private readStorage(key: string): string | null {
      try {
         return localStorage.getItem(key);
      } catch {
         return null;
      }
   }

   private writeStorage(key: string, value: string): void {
      try {
         localStorage.setItem(key, value);
      } catch {
         /* ignore quota / private mode */
      }
   }
}
